import { render, staticRenderFns } from "./userCouponList.vue?vue&type=template&id=50375d6b"
import script from "./userCouponList.vue?vue&type=script&lang=js"
export * from "./userCouponList.vue?vue&type=script&lang=js"
import style0 from "./userCouponList.vue?vue&type=style&index=0&id=50375d6b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports